<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 14:12:20
 * @LastEditTime: 2020-06-20 16:52:30
 * @Description: 答题操作栏
 -->
<template>
  <div class="action-bar">
    <pss-button
      text="上一题"
      @on-click="clickPrevBtnHandler"
      :disabled="questionNumber <= 0" />
    <pss-button
      text="下一题"
      @on-click="clickNextBtnHandler"
      :disabled="this.questionNumber >= this.libraryInfo.length - 1" />
    <pss-button
      text="完成"
      @on-click="clickDoneBtnHandler"
      v-if="questionNumber === libraryInfo.length - 1"
      />
    <pss-button text="预览" @on-click="clickPreviewBtnHandler" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActionBar',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
  },
  props: {
    questionNumber: { type: Number, required: true },
  },
  methods: {
    /**
     * 点击上一题按钮处理函数
     */
    clickPrevBtnHandler() {
      this.$emit('prev-question');
    },
    /**
     * 点击下一题按钮处理函数
     */
    clickNextBtnHandler() {
      if (!this.libraryInfo[this.questionNumber].answer) {
        alert('当前题目未作答');
      } else {
        this.$emit('next-question');
      }
    },
    /**
     * 点击完成按钮处理函数
     */
    clickDoneBtnHandler() {
      if (!this.libraryInfo[this.questionNumber].answer) {
        alert('当前题目未作答');
      } else {
        // eslint-disable-next-line no-lonely-if
        if (window.confirm('确认提交试卷吗？')) {
          this.$emit('handler-submit');
        }
      }
    },
    /**
     * 点击预览按钮处理函数
     */
    clickPreviewBtnHandler() {
      this.$emit('preview-question');
    },
  },
};
</script>

<style lang="less" scoped>
.action-bar {
  display: flex;
  justify-content: center;
  width: 100%;

  > a {
    margin-right: 16px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
